<!--
Author: Lsc
Date: 2019-8-22
Desc: 服务定制组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-service-menu bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">
                    个人中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-table
            ref="multipleTable"
            :data="serviceArr"
            tooltip-effect="dark"
            style="width: 100%"
            :row-class-name="tableRowClassName"
            v-on:selection-change="handleSelectionChange"
        >
            <el-table-column
                type="selection"
                width="55"
            >
            </el-table-column>
            <!-- <el-table-column
                label="栏目编号"
                width="200"
                align="center"
            >
                <template slot-scope="scope">
                    {{ scope.row.taskcode }}
                </template>
            </el-table-column> -->
            <el-table-column
                label="栏目名称"
                align="center"
            >
                <template slot-scope="scope">
                    {{ scope.row.taskname }}
                </template>
            </el-table-column>
            <el-table-column
                label="定制类型"
                width="200"
                align="center"
            >
                <template slot-scope="scope">
                    {{ typeName(scope.row.ordermode) }}
                </template>
            </el-table-column>
        </el-table>
        <el-form 
            ref="serviceWayInfo" 
            :rules="rules" 
            label-width="120px" 
            :inline="true" 
            :model="serviceWayInfo"
        >
            <el-form-item label="手机号码：" prop="mobileno">
                <el-input v-model.trim="serviceWayInfo.mobileno" placeholder="请输入接受信息手机号码" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <el-input v-model="serviceWayInfo.email" placeholder="请输入接受信息邮件地址"></el-input>
            </el-form-item>
        </el-form>
        <div class="service-sub">
            <el-button type="primary" class="medium" :disabled="!btnFlag" v-on:click="submitInfo">
                保存设置
            </el-button>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "ServiceMenu",
    mixins: [mixin],
    data () {
        return {
            serviceArr: [
                {
                    ordermode: "1",
                    taskcode: "2000",
                    taskname: "基金净值短信服务"
                },
                // {
                //     ordermode: "1",
                //     taskcode: "2001",
                //     taskname: "基金日净值"
                // },
                {
                    ordermode: "1",
                    taskcode: "2004",
                    taskname: "基金份额信息（季度对账单）"
                },
                {
                    ordermode: "1",
                    taskcode: "2020",
                    taskname: "持有基金周净值"
                },
                {
                    ordermode: "2",
                    taskcode: "9010",
                    taskname: "月度对账单"
                }
            ],
            selectservice: "",
            btnFlag: true,
            datasss: [],
            serviceWayInfo: {},
            rules: {
                mobileno: [
                    { required: true, message: "请输入手机号码", trigger: "blur" },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                email: [
                    { required: true, message: "请输入邮箱地址", trigger: "blur" },
                    { validator: this.validateEmail, trigger: "blur" }
                ]
            }
        };
    },
    mounted () {
        this.getserviceLists();
    },
    methods: {
        getserviceLists () {
            const _this = this;
            this.$util.request("acct/notitication/service", {}, "GET", false).then(res => {
                if (res.data) {
                    let qryService = [];
                    res.data.forEach(em => {
                        qryService.push(_this.serviceArr.filter(item => {
                            return item.taskcode === em.taskcode;
                        })[0]);
                    });
                    this.toggleSelection(qryService);
                }
            });
            this.$util.request("acct/info/cc", {}, "GET", false).then(res => {
                if (res.data) {
                    _this.serviceWayInfo = res.data[0];
                }
            });
        },
        submitInfo () {
            const _this = this;
            this.$refs.serviceWayInfo.validate(valid => {
                if (valid) {
                    _this.btnFlag = false;
                    _this.$util.request("acct/notitication/service", {taskcode: _this.selectservice}, "POST", false).then(res => {
                        if (res.data) {
                            _this.$util.request("acct/info/cc", _this.serviceWayInfo, "PUT", false).then(res => {
                                if (res.data) {
                                    _this.$message({
                                        type: "success",
                                        message: "修改定制信息成功！",
                                        onClose: function() {
                                            _this.btnFlag = true;
                                        }
                                    });
                                } else {
                                    _this.btnFlag = true;
                                }
                            });
                        } else {
                            _this.btnFlag = true;
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row, true);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            let selectArr = [];
            val.forEach(element => {
                selectArr.push(element.taskcode);
            });
            this.selectservice = selectArr.join(",");
        },
        tableRowClassName({row, rowIndex}) {
            if (rowIndex === 4) {
                return "warning-row";
            } else {
                return "success-row";
            }
        },
        typeName (val) {
            return val === "1" ? "短信" : "邮件";
        },
        validateEmail (rule, value, callback) {
            if (value !== "") {
                this.$util.validateEmail(rule, value, callback);
            } else {
                callback();
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-service-menu {
    padding-bottom: 50px;
    .service-sub {
        text-align: center;
    }
    .el-table .warning-row {
        background: oldlace;
    }
}
</style>
